import { formatDateAndTimeLong } from '../../../utils/dateHelpers'
import { IResourceActivityCsvResponse } from './DownloadResourceActivityCSV'
import { t } from '@lingui/macro'

export const prepareCSVResourceActivityExport = (
  data: IResourceActivityCsvResponse[]
) =>
  data.map((row) => ({
    [t`Views count`]: row.viewsCount,
    [t`Last viewed at`]: formatDateAndTimeLong(row.lastViewedAt),

    [t`User name`]: row.userDisplayName,
    [t`User id`]: row.userId,
    [t`User deleted at`]: row.userDeletedAt,

    [t`Workspace name`]: row.workspaceName,
    [t`Workspace id`]: row.workspaceId,
    [t`Resource name`]: row.resourceName,
    [t`Resource id`]: row.resourceId,
    [t`Current resource version`]: row.currentResourceVersion,
    [t`Author first name`]: row.authorFirstName,
    [t`Author last name`]: row.authorLastName,
    [t`Author email`]: row.authorEmail,
    [t`Resource deleted at`]: row.resourceDeletedAt,
    [t`User first name`]: row.userFirstName,
    [t`User last name`]: row.userLastName,
    [t`User email`]: row.userEmail
  }))
